module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PrivateLink', {
    staticClass: "single-card",
    attrs: {
      "to": _vm.to,
      "target": _vm.target,
      "isWrap": _vm.statusType
    }
  }, [_c('div', {
    staticClass: "single-card__content",
    class: {
      'single-card__content_padding': _vm.status && _vm.variant
    }
  }, [(_vm.showClose) ? _c('button', {
    staticClass: "single-card__close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('delete')
      }
    }
  }) : _vm._e(), (_vm.status && _vm.variant) ? _c('div', {
    staticClass: "single-card__status",
    class: _vm.variantClass
  }, [_vm._v(_vm._s(_vm.status))]) : _vm._e(), (_vm.showBadge) ? _c('div', {
    staticClass: "single-card__badge"
  }, [_c('more-badge', {
    staticClass: "single-card__module",
    attrs: {
      "interval": 3000,
      "items": _vm.badge
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "single-card__img",
    class: _vm.imgClass,
    style: (_vm.imgStyle)
  }, [(_vm.labor_program || _vm.length) ? _c('div', {
    staticClass: "single-card__hours"
  }, [(_vm.labor_program) ? _c('div', {
    staticClass: "single-card__labor-count"
  }, [_vm._v(_vm._s(_vm.labor_program))]) : _vm._e(), (_vm.length) ? _c('div', {
    staticClass: "single-card__length-count"
  }, [_vm._v(_vm._s(_vm.length))]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "single-card__textblock"
  }, [_c('MoreTitle', {
    attrs: {
      "constrained": _vm.constrainNameHeight
    }
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.note) ? _c('MoreNote', [_vm._v(_vm._s(_vm.note))]) : _vm._e(), (!_vm.note && _vm.isTextString) ? _c('MoreNote', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e(), (!_vm.note && _vm.isTextArray) ? _c('MoreNote', [
    [_vm._l((_vm.text), function(line, index) {
      return _c('p', {
        key: index
      }, [_vm._v(_vm._s(line))])
    }), (_vm.academicYear) ? _c('div', {
      staticClass: "single-card__year"
    }, [_vm._v(_vm._s(_vm.academicYear))]) : _vm._e()]
  ], 2) : _vm._e()], 1), (_vm.isLockedText) ? _c('Locked', {
    staticClass: "single-card__form-locked",
    attrs: {
      "inlay": true
    }
  }) : _vm._e(), (_vm.formEducation) ? _c('div', {
    staticClass: "single-card__form"
  }, [_vm._v(_vm._s(_vm.formEducation) + "      ")]) : _vm._e()], 1), _c('div', {
    staticClass: "single-card__footer"
  }, [(_vm.message && _vm.variant) ? _c('div', {
    staticClass: "single-card__message",
    class: _vm.variantClass
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), (_vm.price) ? _c('MorePrice', {
    staticClass: "single-card__price",
    attrs: {
      "value": _vm.price
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.hideButton) ? [(!_vm.check) ? _c('div', {
    key: "buttons",
    staticClass: "single-card__buttons"
  }, [(_vm.programCost) ? _c('div', {
    staticClass: "single-card__cost"
  }, [_vm._v(_vm._s(_vm.programCost))]) : _vm._e(), _c('MoreButton', {
    on: {
      "more": _vm.GoToCard
    }
  }), (_vm.statusType) ? _c('MoreButton', {
    attrs: {
      "cancel": _vm.cancel,
      "type": _vm.status
    },
    on: {
      "cancel": function($event) {
        _vm.check = !_vm.check
      },
      "contracts": function($event) {
        return _vm.$emit('contracts', _vm.pfdodUrl)
      }
    }
  }) : _vm._e()], 1) : _c('div', {
    key: "cancel",
    staticClass: "single-card__buttons"
  }, [_c('MoreButton', {
    on: {
      "more": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Да")]), _c('MoreButton', {
    on: {
      "more": function($event) {
        _vm.check = !_vm.check
      }
    }
  }, [_vm._v("Нет")])], 1)] : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ea0328","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/item/single/component.vue
// module id = 7e4b9978002bcee9fc12
// module chunks = 89